import debounce from 'lodash/debounce';

class ResizeManager {
    constructor() {
        this.listeners = new Set();
        this.isListening = false;
        this.debouncedResize = debounce(this.handleResize.bind(this), 500);
    }

    addListener(component) {
        this.listeners.add(component);

        if (!this.isListening) {
            window.addEventListener('resize', this.debouncedResize);
            this.isListening = true;
        }
    }

    removeListener(component) {
        this.listeners.delete(component);

        if (this.listeners.size === 0 && this.isListening) {
            window.removeEventListener('resize', this.debouncedResize);
            this.isListening = false;
        }
    }

    handleResize() {
        this.listeners.forEach((component) => {
            if (component && typeof component.onResize === 'function') {
                component.onResize();
            }
        });
    }
}

const resizeManager = new ResizeManager();

export default {
    data() {
        return {
            isMobile: window.innerWidth < 768,
            isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
            isDesktop: window.innerWidth >= 1024,
        };
    },

    methods: {
        onResize() {
            const wasMobile = this.isMobile;
            const wasTablet = this.isTablet;
            const wasDesktop = this.isDesktop;

            this.isMobile = window.innerWidth < 768;
            this.isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;
            this.isDesktop = window.innerWidth >= 1024;

            this.updateViewportHeight();
            if (typeof this.handleResize === 'function') {
                this.handleResize();
            }

            this.$emit('resize', {
                isMobile: this.isMobile,
                isTablet: this.isTablet,
                isDesktop: this.isDesktop,
                wasMobile,
                wasTablet,
                wasDesktop,
            });
        },

        getBreakpoint() {
            if (this.isMobile) return 'mobile';
            if (this.isTablet) return 'tablet';
            return 'desktop';
        },

        isBreakpoint(breakpoint) {
            const breakpoints = {
                mobile: this.isMobile,
                tablet: this.isTablet,
                desktop: this.isDesktop,
            };
            return breakpoints[breakpoint] || false;
        },

        updateViewportHeight() {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);

            const dvh = window.visualViewport ? window.visualViewport.height * 0.01 : vh;
            document.documentElement.style.setProperty('--dvh', `${dvh}px`);
        },

        handleOrientationChange() {
            setTimeout(() => {
                this.updateViewportHeight();
            }, 100);
        },
    },

    mounted() {
        resizeManager.addListener(this);
        this.updateViewportHeight();

        window.addEventListener('orientationchange', this.handleOrientationChange);
    },

    beforeDestroy() {
        resizeManager.removeListener(this);
        window.removeEventListener('orientationchange', this.handleOrientationChange);
    },
};
